import type { BreakpointValues } from "@porsche-design-system/components-react"
import type { GridItemSize } from "../../grid/GridItem"

export const gridSize: BreakpointValues<GridItemSize> | GridItemSize = { base: 12, s: 6 }
